<template>
  <div class="d-flex flex-column text-center justify-content-center">
    <img class="col-11 daily-draw-img" src="@/assets/rewards/voucher-pop-up-container.png">
    <div class="d-flex flex-column align-items-center voucher-text-container col-10 move">
      <div class="header-title">Congratulations! WooHoo,</div>
      <div class="header-title">You have <b>won a Coupon</b></div>
      <div class="info-text mt-3 col-10">To claim your prize, head over to the voucher store now and access your coupon.</div>
      <div class="pin mt-1">Your <b>PIN</b> is:</div>
      <div class="pin"><b>{{ userPins[0].VoucherPin }}</b></div>
      <div class ="header-title p-2 access-coupon mt-1 col-9" @click="viewRewardClicked"><b>ACCESS COUPON STORE</b></div>
      <div class="header-title underlined" @click="setRewardPopup(false)" >Close</div>
      <div class="mt-3 expire">Unclaimed rewards expire after 7 days</div>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import RewardCampaignService from "@/api/services/rewardsService";
import DcbService from "@/api/services/dcbService";

export default {
  name: "RewardPopup",
  props: ['userPins'],
  computed: {
    ...mapState(['user','brandConfig']),
  },
  data() {
    return {
      unclaimedVouchers: [],
      voucherValue: undefined,
      encryptedMsisdn: null
    }
  },
  methods: {
    ...mapMutations(['setRewardPopup']),
    async encryptMsisdn() {
      let encryptMsisdnResponse = (await DcbService.encryptUserMsisdn(this.user.msisdn)).data;
      this.encryptedMsisdn = encryptMsisdnResponse.encryptedMsisdn;
    },
    async viewRewardClicked() {
      await this.encryptMsisdn();
      window.open(`https://voucher-store-staging.mzrhythm.com/?e-msisdn=${this.encryptedMsisdn}&productId=35`, '_self');
    },
  },
  async beforeMount() {
  }
}
</script>

<style scoped>
.daily-draw-img {
  position: relative;
}

.voucher-text-container {
  position: absolute;
  top: 198px;
  font-family: poppins;
  color: #FFFFFF;
}

.header-title {
  font-size: 17px;
  font-weight: 400;
}

.pin {
  font-size: 14px;
  font-weight: 400;
}

.move{
  left: 10%;
}

.access-coupon{
  background-color: #FFCA00;
  border-radius: 26px;
}

.expire{
  color: #FFCA00;
  font-size: 12px;
}

.underlined{
  text-decoration: underline;
  text-underline-offset: 2px;
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000096;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
